import {
  ReleasePurchaseModel,
  ReleaseSaleModel,
} from 'api-hooks/refund/refund';
import { ReleaseStatusEnum } from 'common/constants/enum';
import * as React from 'react';

export default function useReleaseStatus(
  data?: ReleaseSaleModel | ReleasePurchaseModel | null,
) {
  const releaseStatus = React.useMemo(() => {
    const defaultValues = {
      isRequested: false,
      isDraft: false,
      isPending: false,
      isRejected: false,
      isPendingRefund: false,
    };

    switch (data?.status!) {
      case ReleaseStatusEnum.Requested:
        return {
          ...defaultValues,
          isRequested: true,
        };
      case ReleaseStatusEnum.Draft:
      case ReleaseStatusEnum.DraftRefund:
      case ReleaseStatusEnum.DraftCancelRefund:
        return {
          ...defaultValues,
          isDraft: true,
        };
      case ReleaseStatusEnum.PendingApproval:
      case ReleaseStatusEnum.PendingReleaseApproval:
      case ReleaseStatusEnum.PendingCancelRefund:
      case ReleaseStatusEnum.PendingRefund:
        return {
          ...defaultValues,
          isPending: true,
        };
      case ReleaseStatusEnum.RejectedApproval:
      case ReleaseStatusEnum.RejectedReleaseApproval:
      case ReleaseStatusEnum.RejectRefund:
        return { ...defaultValues, isRejected: true };
      case ReleaseStatusEnum.Completed:
      case ReleaseStatusEnum.CancelRefund:
      case ReleaseStatusEnum.Archived:
      case ReleaseStatusEnum.Waiting:
      default:
        return defaultValues;
    }
  }, [data?.status]);

  return { releaseStatus };
}
